import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import SEO from "../components/SEO";
function Home() {
    const [apptName, setApptName] = useState('')
    const [apptEmail, setApptEmail] = useState('')
    const [apptMobile, setApptMobile] = useState('')
    const [apptService, setApptService] = useState('E-Commerce Solution')
    const [apptMessage, setApptMessage] = useState('')
    const [apptConsent, setApptConsent] = useState(false)

    function handleAppointmentSubmit(e) {
        e.preventDefault()
        if (!apptConsent) {
            alert('Please read and accept the Privacy Policy and Terms & Conditions before submitting.')
            return
        }

        const to = 'info@100eyestechnologies.com'
        const subject = `Appointment request from ${apptName || apptEmail}`
        const body = `Name: ${apptName}\nEmail: ${apptEmail}\nMobile: ${apptMobile}\nService: ${apptService}\n\nMessage:\n${apptMessage}`
        const mailto = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
        window.location.href = mailto
    }
const structuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "100 Eyes Technologies LLP",
  "url": "https://100eyestechnologies.com",
  "logo": "https://100eyestechnologies.com/img/logo.webp",
  "foundingDate": "2025-10-01",
  "founders": [
    {
      "@type": "Person",
      "name": "Umesh Aggarwal"
    }
  ],
    "description": "100 Eyes Technologies LLP is a Delhi-based IT company offering custom software development, web & mobile applications, cloud integration, and digital transformation solutions for startups and SMEs worldwide.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "New Delhi",
    "addressRegion": "Delhi",
    "addressCountry": "India"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-7011158577",
    "contactType": "customer support",
    "email": "info@100eyestechnologies.com",
    "availableLanguage": ["English", "Hindi"]
  },
  "sameAs": [
    "https://www.linkedin.com/company/100eyestechnologies",
    "https://www.facebook.com/100eyestechnologies",
    "https://www.instagram.com/100eyestechnologies",
    "https://twitter.com/100eyestech"
  ],
  "knowsAbout": [
    "Custom Software Development",
    "Web Application Development",
    "Mobile App Development",
    "Cloud Solutions",
    "E-Commerce Solutions",
    "CRM and ERP Systems",
    "Technical Resource Payroll",
    "Content Management Systems",
    "AI and Automation"
  ],
  "serviceType": "Software & Cloud Development Services",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Technology Solutions Offered by 100 Eyes Technologies",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Custom Software Development",
          "description": "Tailored software solutions built with modern frameworks for scalability and performance."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Web and Mobile App Development",
          "description": "Building responsive and high-performance web & mobile applications."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Cloud Solutions & Integration",
          "description": "Deploy, manage, and scale applications securely using cloud infrastructure."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Digital Transformation Consulting",
          "description": "Helping enterprises modernize systems, automate workflows, and embrace AI-powered tools."
        }
      }
    ]
  }
};
    return (
        <>
                    <SEO
                        title="Custom Software, Web & Mobile Apps, Cloud Solutions"
                        description="100 Eyes Technologies provides custom software development, responsive web & mobile applications, cloud and digital transformation services for startups and SMEs."
                    >
                        {/* JSON-LD structured data */}
                        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
                    </SEO>
            <div>

                {/* About Start */}
                <div className="container-fluid py-5">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
                                <div className="row g-0">
                                    <div className="col-6">
                                    <img className="img-fluid" src="img/banner 4.webp" alt="100Eyes banner graphic" />
                                    </div>
                                    <div className="col-6">
                                    <img className="img-fluid" src="img/ecommerce banner.webp" alt="Ecommerce solutions banner" />
                                    </div>
                                    <div className="col-6">
                                    <img className="img-fluid" src="img/unnamed.webp" alt="Decorative graphic" />
                                    </div>
                                    <div className="col-6">
                                        <div className="bg-primary w-100 h-100 mt-n5 ms-n5 d-flex flex-column align-items-center justify-content-center">
                                            <div className="icon-box-light">
                                                <i className="bi bi-award text-dark" />
                                            </div>
                                            <h1 className="display-1 text-white mb-0" data-toggle="counter-up">10</h1>
                                            <small className="fs-5 text-white">Years Experience</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
                                <h1 className="display-6 mb-4">Trusted Expertise. Proven Technology. Future-Ready SaaS Solutions.</h1>
                                <p className="mb-4">With a commitment to quality and innovation, we deliver secure, scalable, and intelligent solutions designed for enterprise-level performance.</p>
                                <div className="row g-4 g-sm-5 justify-content-center">
                                    <div className="col-sm-6">
                                        <div className="about-fact btn-square flex-column rounded-circle bg-primary ms-sm-auto">
                                            <p className="text-white mb-0">Next-Gen Innovations</p>
                                            <h1 className="text-white mb-0" data-toggle="counter-up">2050</h1>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 text-start">
                                        <div className="about-fact btn-square flex-column rounded-circle bg-secondary me-sm-auto">
                                            <p className="text-white mb-0">Powering Future</p>
                                            <h1 className="text-white mb-0" data-toggle="counter-up">2025</h1>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="about-fact mt-n130 btn-square flex-column rounded-circle bg-dark mx-sm-auto">
                                            <p className="text-white mb-0">Bridging Trust</p>
                                            <h1 className="text-white mb-0" data-toggle="counter-up">2014-</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* About End */}
                {/* Features Start */}
                <div className="container-fluid py-5">
                    <div className="container">
                        <div className="row g-0 feature-row">
                            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
                                <div className="feature-item border h-100 p-5">
                                    <div className="icon-box-primary mb-4">
                                        <i className="bi bi-award text-dark" />
                                    </div>
                                    <h5 className="mb-3">Next-Gen SaaS Innovations</h5>
                                    <p className="mb-0">Transform your digital ecosystem with technology leaders who understand innovation, performance, and reliability.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
                                <div className="feature-item border h-100 p-5">
                                    <div className="icon-box-primary mb-4">
                                        <i className="bi bi-people text-dark" />
                                    </div>
                                    <h5 className="mb-3">Powering the Future</h5>
                                    <p className="mb-0">From strategy to execution, we help organizations innovate faster and operate smarter using the latest SaaS technologies.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
                                <div className="feature-item border h-100 p-5">
                                    <div className="icon-box-primary mb-4">
                                        <i className="bi bi-cash-coin text-dark" />
                                    </div>
                                    <h5 className="mb-3">Bridging Trust</h5>
                                    <p className="mb-0">We bring visionary tech leadership and the newest SaaS capabilities to redefine how businesses scale, adapt, and thrive.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
                                <div className="feature-item border h-100 p-5">
                                    <div className="icon-box-primary mb-4">
                                        <i className="bi bi-headphones text-dark" />
                                    </div>
                                    <h5 className="mb-3">10/7 Support</h5>
                                    <p className="mb-0">We believe consistent effort needs balanced relief, because just like you, every professional deserves time to recharge. With us, you get a partner who values both your success and your peace of mind</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Features End */}
                {/* Features Start */}
                <div className="container-fluid feature mt-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="container">
                        <div className="row g-0">
                            <div className="col-lg-6 pt-lg-5">
                                <div className="bg-white p-5 mt-lg-5">
                                    <h1 className="display-6 mb-4 wow fadeIn" data-wow-delay="0.3s">Leaders in Best Software & Web Solutions</h1>
                                    <p className="mb-4 wow fadeIn" data-wow-delay="0.4s">At 100Eyes Technologies, we don’t just build software — we create intelligent digital ecosystems that empower businesses to perform at their best. Our team blends innovation, precision, and reliability to deliver web and software solutions that stand apart in quality and performance. With a commitment to excellence.</p>
                                    <div className="row g-5 pt-2 mb-5">
                                        <div className="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                                            <div className="icon-box-primary mb-4">
                                                <i className="bi bi-person-plus text-dark" />
                                            </div>
                                            <h5 className="mb-3">Experienced Technology Experts</h5>
                                            <span>With years of proven experience, we bring deep technical expertise, strategic insight, and innovative thinking to every project.</span>
                                        </div>
                                        <div className="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                                            <div className="icon-box-primary mb-4">
                                                <i className="bi bi-check-all text-dark" />
                                            </div>
                                            <h5 className="mb-3">Security Trends Shaping the Future</h5>
                                            <span>In a world of evolving digital threats, staying ahead means staying informed. We continuously monitor emerging security trends.</span>
                                        </div>
                                    </div>
                                    <a className="btn btn-primary py-3 px-5 wow fadeIn" data-wow-delay="0.5s" href>Explore More</a>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row h-100 align-items-end">
                                    <div className="col-12 wow fadeIn" data-wow-delay="0.3s">
                                        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 300 }}>
                                            <button type="button" className="btn-play" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/DWRcNpR6Kdc" data-bs-target="#videoModal">
                                                <span />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="bg-primary p-5">
                                            <div className="experience mb-4 wow fadeIn" data-wow-delay="0.3s">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <span className="text-white">Analysis & Design</span>
                                                    <span className="text-white">92%</span>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-dark" role="progressbar" aria-valuenow={92} aria-valuemin={0} aria-valuemax={100} />
                                                </div>
                                            </div>
                                            <div className="experience mb-4 wow fadeIn" data-wow-delay="0.4s">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <span className="text-white">Result Accuracy</span>
                                                    <span className="text-white">95%</span>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-dark" role="progressbar" aria-valuenow={95} aria-valuemin={0} aria-valuemax={100} />
                                                </div>
                                            </div>
                                            <div className="experience mb-0 wow fadeIn" data-wow-delay="0.5s">
                                                <div className="d-flex justify-content-between mb-2">
                                                    <span className="text-white">Delivery commitments</span>
                                                    <span className="text-white">100%</span>
                                                </div>
                                                <div className="progress">
                                                    <div className="progress-bar bg-dark" role="progressbar" aria-valuenow={100} aria-valuemin={0} aria-valuemax={100} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Features End */}
                {/* Video Modal Start */}
                <div className="modal modal-video fade" id="videoModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content rounded-0">
                            <div className="modal-header">
                                <h3 className="modal-title" id="exampleModalLabel">Youtube Video</h3>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                {/* 16:9 aspect ratio */}
                                <div className="ratio ratio-16x9">
                                        <iframe className="embed-responsive-item" id="video" title="Intro video" src="" allowFullScreen allowscriptaccess="always" allow="autoplay" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Video Modal End */}
                {/* Service Start */}
                                <div className="container-fluid container-service py-5">
                                    <div className="container pt-5">
                                        <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: 600 }}>
                                            <h1 className="display-6 mb-3">Reliable &amp; High-Quality Software Engineering Service</h1>
                                            <p className="mb-5">Delivering software solutions you can trust, built with precision and performance.
                                                High-quality engineering that turns ideas into scalable, reliable products.</p>
                                        </div>
                                        <div className="row g-4">
                                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                                                <div className="service-item">
                                                    <div className="icon-box-primary mb-4">
                                                        <i className="bi bi-heart-pulse text-dark" />
                                                    </div>
                                                    <h5 className="mb-3">E-Commerce development</h5>
                                                    <p className="mb-4">
                                                        Ready to Use & Customizable
                                                        Web, Android &amp; iOS App
                                                        <br />
                                                        We design and develop robust web applications and mobile apps for Android and iOS, tailored to your business needs. Our solutions ensure seamless user experiences, high performance, and future-ready scalability—empowering your business to reach customers everywhere.
                                                    </p>

                                                    <Link className="btn btn-light px-3" to="ecommerce">Read More<i className="bi bi-chevron-double-right ms-1" /></Link>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                                                <div className="service-item">
                                                    <div className="icon-box-primary mb-4">
                                                        <i className="bi bi-lungs text-dark" />
                                                    </div>
                                                    <h5 className="mb-3">Content Management</h5>
                                                    <p className="mb-4">Managing Content Day-to-day update is a refershing the organs of organizations, without organisation seems dull.
                                                        <br />
                                                        this is why we are here to help you out with our best services.
                                                        include: Mangemment system, Website content add/update, SEO, Digital marketing Update.
                                                    </p>
                                                    <a className="btn btn-light px-3" href>Read More<i className="bi bi-chevron-double-right ms-1" /></a>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                                                <div className="service-item">
                                                    <div className="icon-box-primary mb-4">
                                                        <i className="bi bi-virus text-dark" />
                                                    </div>
                                                    <h5 className="mb-3">Business & Enterprise Automation</h5>
                                                    <p className="mb-4">Prevent trees cause by high volume use paper to maintain records.
                                                        <br />
                                                        We are here to help you out with our best services.
                                                        include: Custome software, Enterprise software, Automation software.
                                                        <br />
                                                        bring your business to next level.
                                                    </p>
                                                    <a className="btn btn-light px-3" href>Read More<i className="bi bi-chevron-double-right ms-1" /></a>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                                                <div className="service-item">
                                                    <div className="icon-box-primary mb-4">
                                                        <i className="bi bi-capsule-pill text-dark" />
                                                    </div>
                                                    <h5 className="mb-3">CRMs</h5>
                                                    <p className="mb-4">Dose to maintain your relation provide best services to your customer super fast and secured CRM system.
                                                        <br />
                                                        We are here to help you out with our best services.
                                                        include: Custome CRM, Enterprise CRM, Automation CRM.
                                                        <br />
                                                        Take your customer relationships to the next level with our advanced CRM solutions. We offer seamless integration, automation, and analytics to help you manage leads, track interactions, and deliver personalized experiences. Whether you're a startup or an enterprise, our CRM systems are designed to scale with your business and empower your team to build lasting connections.
                                                    </p>
                                                    <a className="btn btn-light px-3" href>Read More<i className="bi bi-chevron-double-right ms-1" /></a>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                                                <div className="service-item">
                                                    <div className="icon-box-primary mb-4">
                                                        <i className="bi bi-capsule text-dark" />
                                                    </div>
                                                    <h5 className="mb-3">Digital Promotions</h5>
                                                    <p className="mb-4">
                                                        Give your business a daily dose of digital vitality with 100Eyes Technologies. Our Digital Promotion services are the energy shot your brand needs—fueling visibility, engagement, and growth across every online channel. From targeted campaigns to creative content, we blend strategy and innovation to ensure your business stands out and thrives in the digital world. Experience the power of a promotion partner that delivers results as reliably as your morning boost.
                                                    </p>
                                                    <a className="btn btn-light px-3" href>Read More<i className="bi bi-chevron-double-right ms-1" /></a>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                                                <div className="service-item">
                                                    <div className="icon-box-primary mb-4">
                                                        <i className="bi bi-prescription2 text-dark" />
                                                    </div>
                                                    <h5 className="mb-3">Resource on payroll</h5>
                                                    <p className="mb-4">At 100Eyes Technologies, we offer skilled technology resources on payroll to help businesses scale faster with reliable, full-time professionals. Our model allows companies to access top-tier IT talent — including developers, designers, project managers, and QA experts — without the challenges of direct hiring.
                                                        <br />
                                                       We combine expertise, accountability, and flexibility to empower businesses with the right technical talent at the right time. Whether you need to expand your in-house team or build a new one from scratch.
                                                    </p>
                                                    <a className="btn btn-light px-3" href>Read More<i className="bi bi-chevron-double-right ms-1" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Service End */}
                {/* Appoinment Start */}
                <div className="container-fluid py-5">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                                <h1 className="display-6 mb-4">We Ensure You Will Always Get The Best Result</h1>
                                <p>At 100Eyes Technologies, we don’t just deliver projects — we craft outcomes.
Our vision-powered approach ensures innovation, precision, and performance in every line of code.
Because when excellence is the goal, the best result isn’t a promise — it’s our standard.
✨ We Ensure You Will Always Get The Best Result.</p>
                                <p className="mb-4">Every idea deserves the right execution — that’s where 100Eyes Technologies comes in.
We merge creativity, technology, and data-driven strategy to build experiences that perform beyond expectations</p>
                                <div className="d-flex align-items-start wow fadeIn" data-wow-delay="0.3s">
                                    <div className="icon-box-primary">
                                        <i className="bi bi-geo-alt text-dark fs-1" />
                                    </div>
                                    <div className="ms-3">
                                        <h5>Office Address</h5>
                                        <span>392, J BLK, Street 1, Kushak Road 2, Swaroop Nagar, Delhi, India</span>
                                    </div>
                                </div>
                                <hr />
                                <div className="d-flex align-items-start wow fadeIn" data-wow-delay="0.4s">
                                    <div className="icon-box-primary">
                                        <i className="bi bi-clock text-dark fs-1" />
                                    </div>
                                    <div className="ms-3">
                                        <h5>Office Time</h5>
                                        <span>Mon-Sat 10am-10pm, Sun Closed</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                                <h2 className="mb-4">Online Appoinment</h2>
                                <form onSubmit={handleAppointmentSubmit} className="row g-3">
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <input value={apptName} onChange={(e) => setApptName(e.target.value)} type="text" className="form-control" id="name" placeholder="Your Name" />
                                            <label htmlFor="name">Your Name</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <input value={apptEmail} onChange={(e) => setApptEmail(e.target.value)} type="email" className="form-control" id="mail" placeholder="Your Email" />
                                            <label htmlFor="mail">Your Email</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <input value={apptMobile} onChange={(e) => setApptMobile(e.target.value)} type="text" className="form-control" id="mobile" placeholder="Your Mobile" />
                                            <label htmlFor="mobile">Your Mobile</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <select value={apptService} onChange={(e) => setApptService(e.target.value)} className="form-select" id="service">
                                                <option>E-Commerce Solution</option>
                                                <option>Enterprise Software & Web Solutions</option>
                                                <option>Travel Technology system</option>
                                                <option>Content Management System</option>
                                                <option>Custom Software/Web Solution</option>
                                                <option>Digital Promotion</option>
                                                <option>Dev Resources</option>
                                            </select>
                                            <label htmlFor="service">Choose A Service</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-floating">
                                            <textarea value={apptMessage} onChange={(e) => setApptMessage(e.target.value)} className="form-control" placeholder="Leave a message here" id="message" style={{ height: 130 }} defaultValue={""} />
                                            <label htmlFor="message">Message</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-check">
                                            <input checked={apptConsent} onChange={(e) => setApptConsent(e.target.checked)} className="form-check-input" type="checkbox" id="consent" />
                                            <label className="form-check-label" htmlFor="consent">
                                                I have read and agree to the <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms">Terms &amp; Conditions</Link>.
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-12 text-center">
                                        <button className="btn btn-primary w-100 py-3" type="submit">Submit Now</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Appoinment Start */}
                {/* Team Start */}
                <div className="container-fluid container-team py-5 d-none">
                    <div className="container pb-5">
                        <div className="row g-5 align-items-center mb-5">
                            <div className="col-md-6 wow fadeIn" data-wow-delay="0.3s">
                                <img className="img-fluid w-100" src="img/team-1.webp" alt />
                            </div>
                            <div className="col-md-6 wow fadeIn" data-wow-delay="0.5s">
                                <h1 className="display-6 mb-3">Dr. John Martin</h1>
                                <p className="mb-1">CEO &amp; Founder</p>
                                <p className="mb-5">Labsky, New York, USA</p>
                                <h3 className="mb-3">Biography</h3>
                                <p className="mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tellus augue, iaculis id elit eget, ultrices pulvinar tortor. Quisque vel lorem porttitor, malesuada arcu quis, fringilla risus. Pellentesque eu consequat augue.</p>
                                <p className="mb-4">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur tellus augue, iaculis id elit eget, ultrices pulvinar tortor. Quisque vel lorem porttitor, malesuada arcu quis, fringilla risus. Pellentesque eu consequat augue.</p>
                                <div className="d-flex">
                                    <a className="btn btn-lg-square btn-primary me-2" href><i className="fab fa-facebook-f" /></a>
                                    <a className="btn btn-lg-square btn-primary me-2" href><i className="fab fa-twitter" /></a>
                                    <a className="btn btn-lg-square btn-primary me-2" href><i className="fab fa-linkedin-in" /></a>
                                    <a className="btn btn-lg-square btn-primary me-2" href><i className="fab fa-youtube" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="row g-4">
                            <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="team-item">
                                    <div className="position-relative overflow-hidden">
                                        <img className="img-fluid w-100" src="img/team-2.webp" alt />
                                        <div className="team-social">
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-facebook-f" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-twitter" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-linkedin-in" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-youtube" /></a>
                                        </div>
                                    </div>
                                    <div className="text-center p-4">
                                        <h5 className="mb-1">Alex Robin</h5>
                                        <span>Lab Assistant</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                                <div className="team-item">
                                    <div className="position-relative overflow-hidden">
                                        <img className="img-fluid w-100" src="img/team-3.webp" alt />
                                        <div className="team-social">
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-facebook-f" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-twitter" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-linkedin-in" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-youtube" /></a>
                                        </div>
                                    </div>
                                    <div className="text-center p-4">
                                        <h5 className="mb-1">Andrew Bon</h5>
                                        <span>Lab Assistant</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                                <div className="team-item">
                                    <div className="position-relative overflow-hidden">
                                        <img className="img-fluid w-100" src="img/team-4.webp" alt />
                                        <div className="team-social">
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-facebook-f" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-twitter" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-linkedin-in" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-youtube" /></a>
                                        </div>
                                    </div>
                                    <div className="text-center p-4">
                                        <h5 className="mb-1">Martin Tompson</h5>
                                        <span>Lab Assistant</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                                <div className="team-item">
                                    <div className="position-relative overflow-hidden">
                                        <img className="img-fluid w-100" src="img/team-5.webp" alt />
                                        <div className="team-social">
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-facebook-f" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-twitter" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-linkedin-in" /></a>
                                            <a className="btn btn-square btn-light mx-1" href><i className="fab fa-youtube" /></a>
                                        </div>
                                    </div>
                                    <div className="text-center p-4">
                                        <h5 className="mb-1">Clarabelle Samber</h5>
                                        <span>Lab Assistant</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Team End */}
                {/* Testimonial Start */}
                <div className="container-fluid testimonial py-5">
                    <div className="container pt-5">
                        <div className="row gy-5 gx-0">
                            <div className="col-lg-6 pe-lg-5 wow fadeIn" data-wow-delay="0.3s">
                                <h1 className="display-6 text-white mb-4">What Clients Say About Our Services!</h1>
                                <p className="text-white mb-5">At 100Eyes Technologies, we take pride in long-term partnerships built on reliability and results. Our clients appreciate our professional approach, technical expertise, and the measurable impact our solutions bring to their business.</p>
                                <a href className="btn btn-primary py-3 px-5">More Testimonials</a>
                            </div>
                            <div className="col-lg-6 mb-n5 wow fadeIn" data-wow-delay="0.5s">
                                <div className="bg-white p-5">
                                    <div className="owl-carousel testimonial-carousel wow fadeIn" data-wow-delay="0.1s">
                                        <div className="testimonial-item">
                                            <div className="icon-box-primary mb-4">
                                                <i className="bi bi-chat-left-quote text-dark" />
                                            </div>
                                            <p className="fs-5 mb-4">Our clients' success is our greatest achievement. Businesses across industries trust 100Eyes Technologies for our commitment to quality, transparency, and timely delivery. Their words reflect the trust we''ve earned through consistent results and dedicated support.</p>
                                            <div className="d-flex align-items-center">
                                                <img className="flex-shrink-0" src="img/testimonial-1.webp" alt />
                                                <div className="ps-3">
                                                    <h5 className="mb-1">Sayda Jewels</h5>
                                                    <span className="text-primary">Artificial Jewellery Store</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="testimonial-item">
                                            <div className="icon-box-primary mb-4">
                                                <i className="bi bi-chat-left-quote text-dark" />
                                            </div>
                                            <p className="fs-5 mb-4">At 100Eyes Technologies, we take pride in long-term partnerships built on reliability and results. Our clients appreciate our professional approach, technical expertise, and the measurable impact our solutions bring to their business.</p>
                                            <div className="d-flex align-items-center">
                                                <img className="flex-shrink-0" src="img/testimonial-2.webp" alt />
                                                <div className="ps-3">
                                                    <h5 className="mb-1">Womancart</h5>
                                                    <span className="text-primary">Cosmetic ecommerce</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Testimonial End */}
            </div>

        </>
    )
}

// Initialize jQuery plugins that require DOM elements after React mount
// This keeps initialization scoped to the Home page and avoids double-init issues
export function __initHomeCarousels() {
    if (typeof window === 'undefined') return
    const $ = window.jQuery
    if (!$) return
    try {
        if ($('.testimonial-carousel').length && typeof $.fn.owlCarousel === 'function') {
            // destroy existing instance if present to avoid double-init
            try { $('.testimonial-carousel').trigger('destroy.owl.carousel') } catch (e) { /* ignore */ }
            $('.testimonial-carousel').owlCarousel({
                autoplay: true,
                smartSpeed: 1000,
                items: 1,
                loop: true,
                dots: false,
                nav: true,
                navText: ['<i class="bi bi-arrow-left"></i>','<i class="bi bi-arrow-right"></i>']
            })
        }
    } catch (err) {
        // fail silently — plugin may not be available in some environments
        // console.warn('Owl init failed', err)
    }
}

export default function HomeWrapper(props) {
    useEffect(() => {
        __initHomeCarousels()
    }, [])

    return <Home {...props} />
}
